import React from "react";
import styled from "styled-components";

import FormError from "core/FormError";
import BodyText from "core/BodyText";

import { useLoginFlow, VIEWS } from "./Context";

import { convertPxToRem } from "frontend/components/helpers";

const FormErrorStyled = styled(FormError)`
    margin: 0;
`;

const MessageAreaStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${convertPxToRem(16)};
    min-height: ${convertPxToRem(24)};
    padding: ${convertPxToRem(18)} 0;
`;

const MessageArea = () => {
    const { view, backendError } = useLoginFlow();

    let otherMessage = null;

    if (view === VIEWS.CONFIRM_CODE) {
        otherMessage = (
            <BodyText type="p">
                You will receive an email if this is an active account on Noun
                Project. If you do not get an email, check your spam folder or
                try a different email address.
            </BodyText>
        );
    }

    return (
        <MessageAreaStyled>
            {otherMessage}
            {backendError && <FormErrorStyled>{backendError}</FormErrorStyled>}
        </MessageAreaStyled>
    );
};

export default MessageArea;
